module.exports = __webpack_public_path__ + "20250721160708/img/logo_w_icon.f2775b9b.png";